import React, { Component } from 'react';
import moment from 'moment';
import cn from 'classnames';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { RegisterAthlete } from 'routes/routeNames';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import { logPageView, initGA } from 'utils/analytics';
import { is, Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work

import Header from 'components/DashBoardHeader';
import View from 'components/DashboardView';
import Footer from 'components/MiniFooter';
import Session from 'components/Session';
import TrialNotification from 'components/TrialNotification';


import { getSAProfile } from 'containers/Profile-view/actions';
import { selector } from 'containers/Profile-view/redux';
import styles from './Dashboard.scss';

class Dashboard extends Component {

  static propTypes = {
    attributes: PropTypes.shape(),
    profile: PropTypes.shape(),
    history: PropTypes.shape(),
    getSAProfile: PropTypes.func,
    requested: PropTypes.bool,
    subscribed: PropTypes.bool,
  };
  static defaultProps = {
    attributes: {},
    history: {},
    profile: Map(),
    getSAProfile: () => {},
    requested: false,
    subscribed: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      profileId: null,
      tab: 0,
    };
    this.tabListener = this.tabListener.bind(this);
  }

  componentWillMount() {
    const { attributes, history } = this.props;
    if (attributes.size > 0) {
      const zoneinfo = attributes.get('zoneinfo');
      if (!(zoneinfo === 'STUDENT' || zoneinfo === 'ADMIN')) {
        history.goBack();
      }
    }
  }

  componentDidMount() {
    initGA();
    logPageView(this.props.match.path); // eslint-disable-line

    if (this.props.profile && this.props.profile.size > 0) {
      const saSports = this.props.profile.get('sports');
      const keys = saSports.keySeq().toArray();
      const sport = saSports.get(keys[0]);
      const positions = {};
      const academic = this.props.profile.get('academic');
      let primary_offensive_position_pref = ''; //eslint-disable-line
      let primary_defensive_position_pref = ''; //eslint-disable-line
      let secondary_offensive_position_pref = ''; //eslint-disable-line
      let secondary_defensive_position_pref = ''; //eslint-disable-line
      let special_teams = ''; //eslint-disable-line
      if (sport.get('primary_offensive_position_pref') !== undefined) {
            primary_offensive_position_pref = sport.get('primary_offensive_position_pref'); //eslint-disable-line
            if (primary_offensive_position_pref === 'QBDT' || primary_offensive_position_pref === 'QBPS') { //eslint-disable-line
                primary_offensive_position_pref = 'QB'; //eslint-disable-line
            }
            if (primary_offensive_position_pref === 'SR' || primary_offensive_position_pref === 'WR') { //eslint-disable-line
                primary_offensive_position_pref = 'WR'; //eslint-disable-line
            }
            if (primary_offensive_position_pref === 'RB' ||primary_offensive_position_pref ===  'FB' ||primary_offensive_position_pref ===  'HB') {//eslint-disable-line
                primary_offensive_position_pref = 'RB';//eslint-disable-line
            }
            if (primary_offensive_position_pref === 'OG' ||primary_offensive_position_pref ===  'OT' ||primary_offensive_position_pref ===  'C') {//eslint-disable-line
                primary_offensive_position_pref = 'OL';//eslint-disable-line
            }
            positions['primary_offensive_position_pref'] = primary_offensive_position_pref; //eslint-disable-line
      }
      if (sport.get('primary_defensive_position_pref') !== undefined) {
            primary_defensive_position_pref = sport.get('primary_defensive_position_pref'); //eslint-disable-line
            if(primary_defensive_position_pref === 'ML' ||primary_defensive_position_pref ===  'OL'){//eslint-disable-line
                primary_defensive_position_pref = 'LB';//eslint-disable-line
            }
            if(primary_defensive_position_pref === 'SS' || primary_defensive_position_pref ===  'FS'){//eslint-disable-line
                primary_defensive_position_pref = 'S';//eslint-disable-line
            }
            positions['primary_defensive_position_pref'] = primary_defensive_position_pref; //eslint-disable-line
      }
      if (sport.get('secondary_offensive_position_pref') !== undefined) {
            secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref'); //eslint-disable-line
            if (secondary_offensive_position_pref === 'QBDT' ||secondary_offensive_position_pref ===  'QBPS') { //eslint-disable-line
                secondary_offensive_position_pref = 'QB'; //eslint-disable-line
            }
            if (secondary_offensive_position_pref === 'SR' ||secondary_offensive_position_pref ===  'WR') { //eslint-disable-line
                secondary_offensive_position_pref = 'WR'; //eslint-disable-line
            }
            if (secondary_offensive_position_pref === 'RB' ||secondary_offensive_position_pref ===  'FB' ||secondary_offensive_position_pref ===  'HB') {//eslint-disable-line
                secondary_offensive_position_pref = 'RB';//eslint-disable-line
            }
            if (secondary_offensive_position_pref === 'OG' ||secondary_offensive_position_pref ===  'OT' ||secondary_offensive_position_pref ===  'C') {//eslint-disable-line
                secondary_offensive_position_pref = 'OL';//eslint-disable-line
            }
            positions['secondary_offensive_position_pref'] = secondary_offensive_position_pref; //eslint-disable-line
      }
      if (sport.get('secondary_defensive_position_pref') !== undefined) {
            secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref'); //eslint-disable-line
            if(secondary_defensive_position_pref === 'ML' ||secondary_defensive_position_pref ===  'OL'){//eslint-disable-line
                secondary_defensive_position_pref = 'LB';//eslint-disable-line
            }
            if(secondary_defensive_position_pref === 'SS' ||secondary_defensive_position_pref ===  'FS'){//eslint-disable-line
                secondary_defensive_position_pref = 'S';//eslint-disable-line
            }
            positions['secondary_defensive_position_pref'] = secondary_defensive_position_pref; //eslint-disable-line
      }
      if (sport.get('special_teams') !== undefined) {
            special_teams = sport.get('special_teams'); //eslint-disable-line
            positions['special_teams'] = special_teams; //eslint-disable-line
      }
      const newState = {
            // profile
        gender: this.props.profile.get('gender'),
        fullname: this.props.profile.get('fullname'),
        state: this.props.profile.get('sa_state'),
        city: this.props.profile.get('city'),

            // sports
        height: this.props.profile.get('height'),
        weight: this.props.profile.get('weight'),
        sportName: keys[0],
        t40: sport.get('t40'),
        bench: sport.get('bench'),
        squats: sport.get('squats'),
        description: sport.get('description'),
        position_pref: positions,
        sa_image: this.props.profile.get('profile_image'),
        sa_email: this.props.profile.get('sa_email'),
            // school
        school: this.props.profile.get('school'),
        year_of_graduation: academic.get('year_of_graduation'),
        gpa: academic.get('gpa'),
        sat: academic.get('sat'),
        act: academic.get('act'),

        profileId: this.props.profile.get('id'),
        currentDivision: this.props.profile.get('current_division'),
        overrideDivision: this.props.profile.get('override_division'),
      };
      this.setState(newState); //eslint-disable-line
    } else if (this.props.attributes && this.props.attributes.size > 0) {
      const saProfile = this.props.attributes.get('profile');
      if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
        this.props.getSAProfile(saProfile);
      } else {
        this.props.history.push(RegisterAthlete);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { attributes, profile } = this.props;
    if (!this.props.requested && nextProps.attributes && !is(nextProps.attributes, attributes)) {
      const saProfile = nextProps.attributes.get('profile');
      if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
        this.props.getSAProfile(saProfile);
      } else {
        this.props.history.push(RegisterAthlete);
      }
    } else if (nextProps.profile.size > 0 && !is(nextProps.profile, profile)) {
      const saSports = nextProps.profile.get('sports');
      const keys = saSports.keySeq().toArray();
      const sport = saSports.get(keys[0]);
      const academic = nextProps.profile.get('academic');
      const positions = {};
      let primary_offensive_position_pref = ''; //eslint-disable-line
      let primary_defensive_position_pref = ''; //eslint-disable-line
      let secondary_offensive_position_pref = ''; //eslint-disable-line
      let secondary_defensive_position_pref = ''; //eslint-disable-line
      let special_teams = ''; //eslint-disable-line
      if (sport.get('primary_offensive_position_pref') !== undefined) {
            primary_offensive_position_pref = sport.get('primary_offensive_position_pref'); //eslint-disable-line
            if (primary_offensive_position_pref === 'QBDT' || primary_offensive_position_pref === 'QBPS') { //eslint-disable-line
                primary_offensive_position_pref = 'QB'; //eslint-disable-line
            }
            if (primary_offensive_position_pref === 'SR' || primary_offensive_position_pref === 'WR') { //eslint-disable-line
                primary_offensive_position_pref = 'WR'; //eslint-disable-line
            }
            if (primary_offensive_position_pref === 'RB' ||primary_offensive_position_pref ===  'FB' ||primary_offensive_position_pref ===  'HB') {//eslint-disable-line
                primary_offensive_position_pref = 'RB';//eslint-disable-line
            }
            if (primary_offensive_position_pref === 'OG' ||primary_offensive_position_pref ===  'OT' ||primary_offensive_position_pref ===  'C') {//eslint-disable-line
                primary_offensive_position_pref = 'OL';//eslint-disable-line
            }
            positions['primary_offensive_position_pref'] = primary_offensive_position_pref; //eslint-disable-line
      }
      if (sport.get('primary_defensive_position_pref') !== undefined) {
            primary_defensive_position_pref = sport.get('primary_defensive_position_pref'); //eslint-disable-line
            if(primary_defensive_position_pref === 'ML' ||primary_defensive_position_pref ===  'OL'){//eslint-disable-line
                primary_defensive_position_pref = 'LB';//eslint-disable-line
            }
            if(primary_defensive_position_pref === 'SS' || primary_defensive_position_pref ===  'FS'){//eslint-disable-line
                primary_defensive_position_pref = 'S';//eslint-disable-line
            }
            positions['primary_defensive_position_pref'] = primary_defensive_position_pref; //eslint-disable-line
      }
      if (sport.get('secondary_offensive_position_pref') !== undefined) {
            secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref'); //eslint-disable-line
          if (secondary_offensive_position_pref === 'QBDT' ||secondary_offensive_position_pref ===  'QBPS') { //eslint-disable-line
              secondary_offensive_position_pref = 'QB'; //eslint-disable-line
          }
          if (secondary_offensive_position_pref === 'SR' ||secondary_offensive_position_pref ===  'WR') { //eslint-disable-line
              secondary_offensive_position_pref = 'WR'; //eslint-disable-line
          }
          if (secondary_offensive_position_pref === 'RB' ||secondary_offensive_position_pref ===  'FB' ||secondary_offensive_position_pref ===  'HB') {//eslint-disable-line
              secondary_offensive_position_pref = 'RB';//eslint-disable-line
          }
          if (secondary_offensive_position_pref === 'OG' ||secondary_offensive_position_pref ===  'OT' ||secondary_offensive_position_pref ===  'C') {//eslint-disable-line
              secondary_offensive_position_pref = 'OL';//eslint-disable-line
          }
            positions['secondary_offensive_position_pref'] = secondary_offensive_position_pref; //eslint-disable-line
      }
      if (sport.get('secondary_defensive_position_pref') !== undefined) {
            secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref'); //eslint-disable-line
          if(secondary_defensive_position_pref === 'ML' ||secondary_defensive_position_pref ===  'OL'){//eslint-disable-line
              secondary_defensive_position_pref = 'LB';//eslint-disable-line
          }
          if(secondary_defensive_position_pref === 'SS' ||secondary_defensive_position_pref ===  'FS'){//eslint-disable-line
              secondary_defensive_position_pref = 'S';//eslint-disable-line
          }
          positions['secondary_defensive_position_pref'] = secondary_defensive_position_pref; //eslint-disable-line
      }
      if (sport.get('special_teams') !== undefined) {
            special_teams = sport.get('special_teams'); //eslint-disable-line
            positions['special_teams'] = special_teams; //eslint-disable-line
      }
      let questionAireLink = '';
      if (nextProps.profile.get('football_questionaire_page') !== undefined) {
        questionAireLink = nextProps.profile.get('football_questionaire_page');
      }
      let footballTeamPage = '';
      if (nextProps.profile.get('football_questionaire_page') !== undefined) {
        footballTeamPage = nextProps.profile.get('football_team_page');
      }
      const newState = {
                // profile
        gender: nextProps.profile.get('gender'),
        fullname: nextProps.profile.get('fullname'),
        state: nextProps.profile.get('sa_state'),
        city: nextProps.profile.get('city'),

                // sports
        height: nextProps.profile.get('height'),
        weight: nextProps.profile.get('weight'),
        sportName: keys[0],
        t40: sport.get('t40'),
        bench: sport.get('bench'),
        squats: sport.get('squats'),
        description: sport.get('description'),
        position_pref: positions,
        sa_image: nextProps.profile.get('profile_image'),
        sa_email: nextProps.profile.get('sa_email'),

          // school
        school: nextProps.profile.get('school'),
        year_of_graduation: academic.get('year_of_graduation'),
        gpa: academic.get('gpa'),
        sat: academic.get('sat'),
        act: academic.get('act'),

        profileId: nextProps.profile.get('id'),
        video: nextProps.profile.get('video_items').toJS(),
        wishList: nextProps.profile.get('sa_wishlist'),
        ignoreList: nextProps.profile.get('sa_ignorelist'),
        contactedList: nextProps.profile.get('sa_contactedlist'),
        fillQList: nextProps.profile.get('sa_fill_questionaire_list'),
        inviteToCampList: nextProps.profile.get('sa_invited_to_camp_list'),
        footballTeamPage,
        questionAireLink,
        currentDivision: nextProps.profile.get('current_division'),
        overrideDivision: nextProps.profile.get('override_division'),
      };
      this.setState(newState);
    }
  }

  tabListener(tab) {
    this.setState({ tab });
  }

  render() {
    let onTrial = false;
    if (this.props.profile !== undefined) {
      if (this.props.profile.get('trialEndDate')) {
        onTrial = moment().isBefore(this.props.profile.get('trialEndDate'));
      }
    }
    return (
      <div className={cn('row', styles.dashboardContainer)}>
        {(!this.props.subscribed && onTrial) && <TrialNotification trialEndDate={this.props.profile.get('trialEndDate')} />}
        <Header tabListener={this.tabListener} {...this.props} usedFor="athleteDashboard" />
        <View {...this.props} {...this.state} />
        <Footer />
      </div>
    );
  }
}

export default connect(selector,
    { getSAProfile })(Session(Dashboard));



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js